import { createSelector } from '@reduxjs/toolkit';
import { formatPhone } from '../../utils';
import { getCookie } from '../../utils/common';
import slaConfig from '../../components/Sla/slaConfig.json';
import {
  PURPLE_PREMIUM_PLUS_SMART_BASE,
  PURPLE_PREMIUM_SMART_BASE,
} from '../../utils/common/constants';

export const selectCartShippingAddress = (state) => state.cart?.shippingAddress;

export const selectCustomerAddress = (state) => state.accounts?.customerAddress;

export const selectShippingAddresFromCustomerOrCart = createSelector(
  [selectCartShippingAddress, selectCustomerAddress],
  (cartShippingAddress, customerAddress) => {
    const shippingAddress =
      customerAddress && Object.keys(customerAddress).length
        ? {
            ...customerAddress,
            ...(!customerAddress?.streetAddress && {
              streetAddress: customerAddress?.streetName,
            }),
          }
        : cartShippingAddress ?? {};
    const phone = formatPhone(shippingAddress.phone ?? '');

    return {
      ...shippingAddress,
      ...(phone ? { phone } : {}),
    };
  },
);

export const selectIsOverwritePaidInHomeShippingABTest = (state) => {
  if (
    !getCookie(process.env.OVERWRITE_PAID_IN_HOME_SHIPPING_AB_TEST_COOKIE_NAME)
      ?.value ||
    !state.cart?.lineItems?.length
  ) {
    return false;
  }

  let hasMattress = false;
  let hasBase = false;

  state.cart?.lineItems?.forEach((lineItem) => {
    const isMattress = !!slaConfig.mattress.find(
      (mattress) => mattress.key === lineItem.productKey,
    );
    const isSmartBase = [
      PURPLE_PREMIUM_SMART_BASE,
      PURPLE_PREMIUM_PLUS_SMART_BASE,
    ].includes(lineItem.productKey);
    if (isMattress) {
      hasMattress = true;
    }
    if (isSmartBase) {
      hasBase = true;
    }
  });
  return hasMattress && hasBase;
};

export const selectHasMattressInCart = (state) =>
  state.cart?.lineItems?.reduce(
    (prev, lineItem) =>
      prev ||
      !!slaConfig.mattress.find(
        (mattress) => mattress.key === lineItem.productKey,
      ),
    false,
  ) ?? false;

export const selectCartLineItems = (state) => state.cart.lineItems;
